import { Box, CircularProgress, Dialog, DialogContent, DialogTitle, List, ListItem, ListItemButton, ListItemText } from '@mui/material'
import React, { useState } from 'react'
import { blobSAS } from '../Helper/BlobHelper'
import { useSnackbar } from 'notistack'
import JsFileDownloader from 'js-file-downloader'
// import JsFileDownloader from 'js-file-downloader';
// import { downloadFileBrowser } from 'ipull';

const AssetList = (props) => {

  const [loading, setLoading] = useState(false)
  const { enqueueSnackbar } = useSnackbar();


  const download = async (url, projectName, assetname, asset_source) => {

    // alert(asset_source)
    setLoading(true)

    var sasToken = await blobSAS({ token_type: 'read_only', container_name: 'project-executables' })

    url = sasToken.fd_account_url + url + "?" + sasToken.read_only?.['project-executables'].sas_token

    let source = asset_source.split("/")
    let fileExtension = source[source.length - 1]
    let extension = fileExtension.split(".")
    let fileTypeExtension = extension[extension.length - 1]

    let fileName = projectName + assetname + "." + fileTypeExtension


    new JsFileDownloader({ url: url, filename: fileName, timeout: 0 })
      .then(function () {
        // Called when download ended
        setLoading(false)
        enqueueSnackbar('File Downloaded Successfully ', {
          variant: 'success'
        });
      })
      .catch(function (error) {
        // Called when an error occurred
        setLoading(false)
        console.log(error)
        enqueueSnackbar('Something went wrong!', {
          variant: 'error'
        });
      });

    // const downloader = downloadFileBrowser({
    //   url: url,
    //   directory: './downloads', // or 'savePath' for full path
    //   cliProgress: true, // Show progress bar in the CLI (default: false)
    //   parallelStreams: 3 // Number of parallel connections (default: 3)
    // });

    // downloader.download();
  }

  return (
    <div>
      <List dense={true}>
        {props.assets.map((data, index) => {
          return (
            <ListItemButton onClick={() => download(data.asset_source, props.projectName, data.name, data.asset_source)}>
              <ListItem>
                <ListItemText
                  primary={data.name}
                  secondary={data.description ? data.description : null}
                />
              </ListItem>
            </ListItemButton>
          )
        })}
      </List>
      <Dialog maxWidth="xs" fullWidth={true} open={loading}  >
        <DialogTitle marginTop="2px" spacing={2} display="flex" justifyContent="center" alignItems="center">Downloading...</DialogTitle>
        <DialogContent>
          <Box display="flex" justifyContent="center" alignItems="center" margin={2}>
            <CircularProgress />
            {/* <Box width="100%" mr={1}>
              <LinearProgress variant="determinate" value={this.state.progress} />
            </Box>
            <Box minWidth={35}>
              <Typography variant="body2" color="primary">{`${Math.round(
                this.state.progress,
              )}%`}</Typography>
            </Box> */}
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default AssetList